import { jsx as _jsx } from "react/jsx-runtime";
import { Slider } from '@mui/material';
const RangeSlider = ({ value, handleChangeRange, valueText, ariaLabel, marks = false }) => {
    return (_jsx(Slider, { getAriaLabel: ariaLabel, value: value, onChange: handleChangeRange, valueLabelDisplay: 'off', disableSwap: true, getAriaValueText: valueText, marks: true, track: 'inverted', step: 1, min: 0, max: 12 }));
};
export default RangeSlider;
